export enum StowageRulePropertyOperator {
    Unknown,
    Equals,
    IsGreaterThan,
    IsLessThan,
    IsGreaterOrEqualThan,
    IsLessOrEqualThan,
    Contains,
    DoesNotContain,
    IsNotEqualTo,
}
